import { render, staticRenderFns } from "./EmployeeBenefitsFaq.vue?vue&type=template&id=68465d92&"
import script from "./EmployeeBenefitsFaq.vue?vue&type=script&lang=js&"
export * from "./EmployeeBenefitsFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports